var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-container",staticStyle:{"pointer-events":"none"}},[_c('div',{staticClass:"container content-box"},[_vm._t("parameters")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }